import { get } from './api';
import { InfoPanelType } from '@grays-npm/component-library';
import { NavItem, ListingsTab } from '../components';
import { TabItem } from '../pages';

const endpoints = {
  cmsDataUrl: `${window.envConfig.MURRAY_API_BASE_URL}rendercontent/getjson/sellersappconfig`,
};

type ModalsTextType = {
  title: string;
  body?: string;
  subBody?: string;
  lowerInfoBody?: string;
  actionText?: string;
  successText?: {
    title: string;
    body: string;
  };
};

type SellersCategory = {
  category: string;
  title?: string;
  iconUrl?: string;
  subCategories?: string[];
  pageUrl?: string;
  saleSoldCategories?: string[];
};

type StateOrTerritory = {
  short: string;
  long: string;
};

type DropdownItem = {
  label: string;
  value: string;
};

export type CmsDataType = {
  switchToBuyingUrl: string;
  navigation: NavItem[];
  dashboard: {
    title: string;
    notifications: {
      title: string;
      clear: string;
      seeMore: string;
      empty: string;
    };
  };
  contract: {
    title: string;
    content: string;
  };
  notifications: {
    title: string;
  };

  itemCardDropdownOptions: DropdownItem[];

  listings: {
    tabs: TabItem[];
    infoPanels: {
      tab: ListingsTab;
      title: string;
      type: InfoPanelType;
      message: string;
      dismissable?: boolean;
      link?: string;
      linkLabel?: string;
    }[];
  };
  modals: {
    dashboardPromote: ModalsTextType;
    dashboardContact: ModalsTextType;
    promote: ModalsTextType;
    requestChanges: ModalsTextType;
    contact: ModalsTextType;
    acceptOffer: ModalsTextType;
    rejectOffer: ModalsTextType;
    acceptBid: ModalsTextType;
    paymentDetails: ModalsTextType;
    holdReserve: ModalsTextType;
    lowerReserve: ModalsTextType;
    referredInfo: ModalsTextType;
  };
  sellersCategories: SellersCategory[];
  statesAndTerritories: StateOrTerritory[];
  registerToSell: {
    privacyPolicy: string;
  };
};

export const getCmsData = async (): Promise<CmsDataType> => {
  const results = await get<CmsDataType>({
    url: endpoints.cmsDataUrl,
  });
  return results;
  // return cmsDataMock;
};
